import React from 'react';

import Checkbox from 'material-ui/Checkbox';
import { FormLabel } from 'material-ui/Form';



const renderCheckBoxItem = ({ input, option, label, checked, className, handleCheckChange, meta: { touched, error }, ...rest }) => {
    return (
        <div className={`${'checkBoxDiv'} ${className}`}>
            <Checkbox
                name={input.name}
                checked={checked}
                onChange={handleCheckChange}
                value={option.label}
                color="primary"
            />
            <FormLabel >
                {label}
            </FormLabel>
        </div>
    )
}

export default renderCheckBoxItem;


// WEBPACK FOOTER //
// ./src/helpers/RenderCheckBoxItem.js